import { combineActions, handleActions } from 'redux-actions';

import { resourceStoreTypes, resourceUpserters } from '../core';

import * as actions from './identitiesActions';

const identitiesReducer = handleActions(
  {
    [actions.getIdentities]: (state) => state.merge({ isLoading: true }),
    [actions.getIdentitiesSuccess]: (state, { payload }) => resourceUpserters.upsertResources(state, payload),
    [actions.getIdentitiesFailure]: (state, { payload: error }) => resourceUpserters.completeWithError(state, error),

    [combineActions(
      // optimistic update
      actions.updateIdentity,
      actions.createIdentity,
      actions.deleteIdentity,
      // reconcile the optimistic update
      actions.createIdentitySuccess,
      actions.updateIdentitySuccess,
      actions.deleteIdentitySuccess,
    )]: (state, { payload }) => resourceUpserters.upsertResource(state, payload),

    [combineActions(actions.createIdentityFailure, actions.updateIdentityFailure, actions.deleteIdentityFailure)]: (
      state,
      { payload: error, asyncDispatch },
    ) => {
      asyncDispatch(actions.getIdentities());
      return resourceUpserters.resetResources(state, error);
    },
  },
  resourceStoreTypes.mkQcsSyncResourceStore({ resourceName: 'IDENTITIES' }),
);

export default identitiesReducer;
export const IDENTITIES_REDUCER_KEY = 'identitiesStore';
